export default {
  head_scripts: {
    title: 'Script head',
  },
  body_noscripts: {
    title: 'Noscript del body',
    description: "Inserisci codice subito dopo l'apertura del body",
  },
  google_site_verification: {
    title: 'Verifica sito Google',
    label: 'Codice di verifica sito Google',
  },
  buttons: {
    save: 'Salva',
  },
};
